export default [
  {
    path: '/bypass/:kolok/:jabatan',
    name: 'generalBypassIndex',
    component: () => import('@/views/general/bypass/Index.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
    props: true,
  },
]
